<template>
  <div class="content home-page">
    <Header></Header>
    <div class="info crfff">
      <div class="" @click="back"
           style="width: 80px;height:80px;text-align: center;display: flex;align-items: center;justify-content: center;">
        <img width="50" src="../../static/images/back.png"/>
      </div>
      <div class="fs50 mt50 ac">{{ $t('History') }}</div>
      <div class="list mt100" v-for="(item,key,index) in list">
        <div class="fs33">{{ key }}</div>
        <div class="flex" style="flex-wrap: wrap;">
          <div class="img" v-for="(item1,index) in item">

            <div class="process" v-if="item1.status=='process'">{{ $t('process') }}</div>
            <div class="" v-else>
              <!--视频-->
              <div v-if="item1.format=='video'">
                <!-- Video 标识 -->
                <div style="position: absolute; top: 5px; right: 5px; background: rgba(0,0,0,0.6); color: #fff; font-size: 20px; padding: 2px 6px; border-radius: 3px;">
                  {{ $t('VIDEO') }}
                </div>
                <img style="width: 195px;height: 262px;" :src="item1.original_image_path || require('../../static/images/placeholder.jpg')"  loading="lazy"/>
                <div class="down ac" style="padding:5px 0">
                  <img width="30" style="border-radius: 0;" @click="getLink(item1.image_path,item1.format)"
                       src="../../static/images/big.png">
                </div>
              </div>
              <!--图片-->
              <div class="" v-else>
                <img style="width: 195px;height: 262px;" :src="item1.image_path || require('../../static/images/placeholder.jpg')" loading="lazy"/>
                <div class="down ac" style="padding:5px 0">
                  <img width="30" style="border-radius: 0;" @click="getLink(item1.image_path,item1.format)"
                       src="../../static/images/big.png">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal" slot="mdBox">
        <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
        <div class="image ac">
          <div class="" style="font-size:28px;margin-bottom: 20px;">{{ $t('downTips1') }}</div>

          <div v-if="format=='video'">
                <video style="max-width: 80%" :src="url" controls preload="metadata" ></video>
          </div>
          <div class="" v-else>
            <img :src="url" style="max-width: 80%"/>
          </div>

          <div class="img-tools">
            <div class="ac mt20">
              <div class="input-item mt50" style="margin-bottom: 20px;">
                <div class="input-item2">
                  <input class="input" v-model="url" disabled type="" placeholder="">
                </div>
              </div>
              <button class="button fw7" style="width: 100%;" v-if="url" @click="copy(url)" id="copycode"
                      :data-clipboard-text="url">{{ $t('copyLink') }}
                <img style="margin-left: 10px;" width="28" src="../../static/images/copy1.png"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      list: [],
      imageShow: false,
      url: '',
      format:"",
    }
  },
  created() {
    this.getHome();
  },
  methods: {
    getLink(url,format) {
      this.url = url
      this.format = format
      this.$refs.imgDialog.showMaskFun();
      return;
      let link = document.createElement('a');

      this.$refs.imgDialog.showMaskFun();
      link.href = url;// 图片的 URL
      link.download = '';// 可选，可以设置文件名
      link.click();// 模拟点击下载
    },

    closeTmgDialog() {
      this.url = ""
      this.$refs.imgDialog.closeMask();
    },
    back() {
      this.$router.go(-1);
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getHome() {
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('/api/user/history', null, r => {
        that.$parent.returnCode(r, function () {
          that.list = r.data
          that.$parent.loadModal(false);
        });

      })

    },
  }
}
</script>
<style>
.process {
  min-height: 200px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #6678da66;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/page/history.vue